import { apiUrl } from '../../../config/api';
export async function fetchPlantelesData() {
    const response = await fetch(apiUrl('plantel'));

    if (!response.ok) {
        throw new Error(`Error al cargar planteles (${response.status})`);
    }

    const payload = await response.json();

    if (typeof payload === 'string') {
        return JSON.parse(payload);
    }

    return payload;
}
